import './global.d';
import { SessionManager } from './session-manager';
import { DEFAULT_IDLE_TIMEOUT, DEFAULT_OUTLINK_SELECTOR, SESSION_PARAM } from './constants';
import type { SessionManagerConfig } from './types';

function readConfigFromScript(): Partial<SessionManagerConfig> {
  const script = document.currentScript as HTMLScriptElement | null;
  if (!script) return {};

  const config: Partial<SessionManagerConfig> = {};

  const timeout = script.getAttribute('data-ps-idle-timeout');
  if (timeout) config.idleTimeout = parseInt(timeout, 10) || DEFAULT_IDLE_TIMEOUT;

  const selector = script.getAttribute('data-ps-outlink-selector');
  if (selector) config.outlinkSelector = selector;

  const param = script.getAttribute('data-ps-session-param');
  if (param) config.sessionParam = param;

  const domain = script.getAttribute('data-ps-cookie-domain');
  if (domain) config.cookieDomain = domain;

  const geoEndpoint = script.getAttribute('data-geo-endpoint');
  if (geoEndpoint) config.geoEndpoint = geoEndpoint;

  const contextTimeout = script.getAttribute('data-context-timeout');
  if (contextTimeout) config.contextTimeout = parseInt(contextTimeout, 10) || undefined;

  return config;
}

// Merge config sources: data attributes < window.PSSessionConfig
const scriptConfig = readConfigFromScript();
const windowConfig = window.PSSessionConfig ?? {};
const mergedConfig: Partial<SessionManagerConfig> = { ...scriptConfig, ...windowConfig };

// Create the session manager
const sessionManager = new SessionManager(mergedConfig);

// Expose on window.PS.session
window.PS = window.PS ?? {};
window.PS.session = sessionManager;

// Decorate links once DOM is ready
function initLinks(): void {
  sessionManager.initLinks();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initLinks);
} else {
  initLinks();
}

export { sessionManager, SessionManager };
export type { SessionManagerConfig, PSSessionManager, SessionContext, SessionGeo, DecisionSessionPayload } from './types';
